var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.438 0.666748C103.271 0.666748 99.0527 2.28133 95.7194 5.61467L83.2194 18.1147L74.8861 9.78133L63.1673 21.5001L82.4382 40.7709L60.5632 62.3855L72.2819 74.1043L93.8965 52.2293L115.771 74.1043L93.8965 95.7188L105.615 107.438L127.23 85.5626L146.501 104.833L158.219 93.1147L149.886 84.7813L162.386 72.2813C169.053 65.6147 169.053 55.7709 162.386 49.1043L146.501 33.2188L167.334 12.3855L155.615 0.666748L134.782 21.5001L118.896 5.61467C115.563 2.28133 111.605 0.666748 107.438 0.666748ZM20.7194 63.948L9.00065 75.6668L17.334 84.0001L5.61523 95.7188C-1.05143 102.386 -1.05143 112.229 5.61523 118.896L21.5007 134.781L0.667318 155.615L12.3861 167.333L33.2194 146.5L49.1048 162.386C55.7715 169.052 65.6152 169.052 72.2819 162.386L84.0007 150.667L92.334 159L104.053 147.281L20.7194 63.948Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.817e6211a55b507afe60a154c27c8197.svg";
export { ForwardRef as ReactComponent };